import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Search } from './components/search';
import styles from './index.module.sass';
import { BuyerItem } from './components/buyer-item';
import {
  $activeBuyer,
  $buyersData,
  $buyersSwitching,
  $localDisabledBuyers,
  $singleBuyerData,
  fetchBuyerByIdFx,
  fetchBuyersListFx,
  setActiveBuyer,
  switchAllBuyersFx,
  updateBuyerFx,
} from '../../store/buyers.store';
import { useStore } from 'effector-react';
import { BuyerInstance } from '../../ts';
import md5 from 'md5';
import { ButtonPrimary } from '@/shared/ui/button';
import { Sorter } from '../../../common/components/sorter';
import { BuyersList } from './components/buyers-list';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { clearOffersData, fetchBuyerOffersListFx } from '../../store/offers.store';
import { ACTIVE_BUYER, ACTIVE_BUYER_TYPE } from '../../constants';

export const Sidebar = ({
  sortOption,
  setSortOption,
  setOrderBy,
  orderBy,
  searchString,
  setSearchString,
  setOffersModalVisible,
  setShowBuyerModal,
  onSelectBuyer,
}: ISidebar) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState<
    {
      id: number;
      label: string;
      type: 'internal' | 'external';
      checked: boolean;
      active: boolean;
      distance: number;
      trades_count: number;
    }[]
  >([]);
  const activeItem = useStore($activeBuyer);
  const [disableAll, setDisableAll] = useState(false);
  const selectedIdFromQuery = searchParams.get('selected_buyer');
  const switching = useStore($buyersSwitching);
  const buyerInfo = useStore($singleBuyerData);
  const activeBuyerId = localStorage.getItem(ACTIVE_BUYER);
  const activeBuyerData = (() => {
    const activeBuyerType = localStorage.getItem(ACTIVE_BUYER_TYPE);
    return activeBuyerType ? JSON.parse(activeBuyerType) : null;
  })();
  const EXTERNAL_TYPE = 'external';
  const navigate = useNavigate();

  // const [setActiveItem] = useState(-1);
  const buyersData = useStore($buyersData);
  const [buyerUpdateLoading, setBuyerUpdateLoading] = useState({
    loading: false,
    id: -1,
  });

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (!isFirstRender.current) {
      fetchBuyersListFx({
        sortBy: sortOption.find((item) => item.active)?.val,
        orderBy,
        search: searchString,
      });
    } else {
      isFirstRender.current = false;
    }
  }, [sortOption, orderBy]);

  useEffect(() => {
    if (data) {
      if (selectedIdFromQuery && !activeItem) {
        // data[+selectedIdFromQuery] &&
        //   onClick(data[+selectedIdFromQuery], +selectedIdFromQuery);
        setActiveBuyer(+selectedIdFromQuery);
        const companies_list: any[] = data;
        const selected_company = companies_list.find(
          (item: any) => item.id === +selectedIdFromQuery,
        );
        (async () =>
          await fetchBuyerByIdFx({
            id: +selectedIdFromQuery,
            md5:
              selected_company?.type === EXTERNAL_TYPE
                ? md5(selected_company.label)
                : undefined,
          }))();
      } else {
        data[0]?.id && setSearchParams({ selected_buyer: String(data[0]?.id) });
      }

      // TODO: сделать поиск компании по id

      let val = false;
      data.map((item: any) => {
        if (!item.checked) val = true;
        val = false;
      });

      setDisableAll(val);
    }
  }, [data]);

  useEffect(() => {
    let val = false;
    if (data) {
      val = data.some((item) => item.checked);
      setDisableAll(val);
    }
  }, [data]);

  useEffect(() => {
    if (buyersData && buyersData?.data?.length > 0) {
      setData(
        buyersData?.data?.map((item: BuyerInstance) => ({
          id: item.id,
          label: item.company_name,
          type: item?.type,
          checked: item.enabled !== 0,
          active: false,
          distance: item.distance,
          trades_count: item.trades_count,
        })),
      );
      //     setActiveItem(0);
      if (activeItem === -1 && !selectedIdFromQuery) {
        (async () => {
          await fetchBuyerByIdFx({
            id: Number(activeBuyerId) || 0,
            md5:
              activeBuyerData?.type === EXTERNAL_TYPE
                ? md5(activeBuyerData?.company_name as string)
                : undefined,
          });
          !selectedIdFromQuery && setActiveBuyer(Number(activeBuyerId));
        })();
      }
    } else {
      setData([]);
    }
  }, [buyersData]);

  const onClick = useCallback(async (item: itemT) => {
    setActiveBuyer(+item.id);
    setSearchParams({ selected_buyer: String(item.id) });
    await fetchBuyerByIdFx({
      id: item.id,
      md5: item?.type === EXTERNAL_TYPE ? md5(item?.label) : undefined,
    });
    onSelectBuyer();
  }, []);

  // async function onClick

  type itemT = { id: number; type: string; label: string };

  return (
    <div className={styles.root}>
      <Search value={searchString} onChange={(e) => setSearchString(e.target.value)} />
      <div className={styles.bottomWrap}>
        {PUBLIC_MODE === 'development' && (
          <ButtonPrimary
            label={'показать предложения выбранных покупателей'}
            className={styles.showButton}
            onClick={() => navigate('/search')}
            //disabled={true}
          />
        )}
        <div className={styles.midControlBar}>
          <Sorter
            className={styles.sorter}
            sortOption={sortOption}
            setSortOption={setSortOption}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
          />

          <div className={styles.switchingBar}>
            <a
              href="#"
              onClick={async (e) => {
                e.preventDefault();
                await switchAllBuyersFx(true);
                await fetchBuyersListFx({
                  sortBy: sortOption.find((item) => item.active)?.val,
                  orderBy,
                  search: searchString,
                });
                // clearOffersData();
                await fetchBuyerOffersListFx({
                  id: Number(buyerInfo?.id),
                  md5:
                    buyerInfo?.type === EXTERNAL_TYPE
                      ? md5(buyerInfo?.company_name)
                      : undefined,
                });
              }}
            >
              {'вкл. всех'}
            </a>
            /
            <a
              href="#"
              onClick={async (e) => {
                e.preventDefault();
                await switchAllBuyersFx(false);
                await fetchBuyersListFx({
                  sortBy: sortOption.find((item) => item.active)?.val,
                  orderBy,
                  search: searchString,
                });
                // clearOffersData();
                await fetchBuyerOffersListFx({
                  id: Number(buyerInfo?.id),
                  md5:
                    buyerInfo?.type === EXTERNAL_TYPE
                      ? md5(buyerInfo?.company_name)
                      : undefined,
                });
              }}
            >
              {'выкл. всех'}
            </a>
          </div>
        </div>

        <BuyersList
          sortOption={sortOption}
          orderBy={orderBy}
          onClick={onClick}
          buyersData={buyersData}
          data={data}
          activeItem={activeItem}
          setActiveBuyer={setActiveBuyer}
          buyerUpdateLoading={buyerUpdateLoading}
          setBuyerUpdateLoading={setBuyerUpdateLoading}
          searchString={searchString}
          setSearchString={setSearchString}
          setShowBuyerModal={setShowBuyerModal}
        />
      </div>
    </div>
  );
};

interface ISidebar {
  sortOption: { label: string; val: string; active: boolean }[];
  setSortOption: (val: { label: string; val: string; active: boolean }[]) => void;
  setOrderBy: (val: 'asc' | 'desc') => void;
  orderBy: 'asc' | 'desc';
  searchString: string;
  setSearchString: (val: string) => void;
  setOffersModalVisible: (val: boolean) => void;
  setShowBuyerModal: (val: boolean) => void;
  onSelectBuyer: () => void;
}

const buyers = [
  { label: 'Покупатель 1', type: 'out', checked: false, active: false },
  {
    label: 'Покупатель 26789809898-08-08-0',
    type: 'in',
    checked: false,
    active: false,
  },
  { label: 'Покупатель 3', type: 'out', checked: true, active: false },
  { label: 'Покупатель 4', type: 'in', checked: false, active: false },
  { label: 'Покупатель 5', type: 'in', checked: false, active: false },
  { label: 'Покупатель 6', type: 'out', checked: false, active: false },
  { label: 'Покупатель 7', type: 'out', checked: false, active: false },
];
